import { SwitchField } from '@@/form-components/SwitchField';

import {
  ProviderCredentialFields,
  CredentialValues,
} from './ProviderCredentialFields';
import { SharedGitCredentialSelect } from './SharedGitCredentialSelect';

export type AuthMode = 'manual' | 'shared';

type AuthenticationValues = CredentialValues & {
  authEnabled: boolean;
  authMode: AuthMode;
  sharedCredentialId?: number;
};

type Props = {
  values: AuthenticationValues;
  errors?: { username?: string; password?: string };
  isEditing?: boolean;
  onChange: (changed: Partial<AuthenticationValues>) => void;
  toggleDataCy: string;
};

export function GitAuthentication({
  values,
  errors,
  isEditing,
  onChange,
  toggleDataCy,
}: Props) {
  const useSharedCredential = values.authMode === 'shared';

  return (
    <>
      <div className="mb-4">
        <SwitchField
          label="Authentication"
          name="authentication"
          checked={values.authEnabled}
          onChange={(value) => onChange({ authEnabled: value })}
          data-cy={toggleDataCy}
        />
      </div>
      {values.authEnabled && (
        <>
          <div className="mb-4">
            <SwitchField
              label="Use a shared credential"
              name="useSharedCredential"
              checked={useSharedCredential}
              onChange={(value) =>
                onChange(
                  value
                    ? { authMode: 'shared', username: '', password: '' }
                    : { authMode: 'manual', sharedCredentialId: undefined }
                )
              }
              data-cy={`${toggleDataCy}-shared-credential-toggle`}
            />
          </div>
          {useSharedCredential ? (
            <SharedGitCredentialSelect
              value={values.sharedCredentialId}
              onChange={(credentialId) =>
                onChange({ sharedCredentialId: credentialId })
              }
              error={errors?.username}
            />
          ) : (
            <ProviderCredentialFields
              values={values}
              errors={errors}
              isEditing={isEditing}
              onChange={onChange}
            />
          )}
        </>
      )}
    </>
  );
}
